<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsRealtimeChart from './AmChartsRealtimeChart.vue'
import ChartJsRealtimeChart from './ChartJsRealtimeChart.vue'
import type { RealtimeChartProps } from './types'

/**
 * Today against yesterday, minute by minute, for **one** of several metrics the screen can
 * switch between: hand it every metric's points at once and change `metric` to switch, and
 * the chart is rebuilt for the one asked for.
 *
 * It brings its own zoom; `start` only says where the axis opens before the reader has
 * zoomed. Yesterday is deliberately the grey line: it is the one being compared against.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsRealtimeChart.vue` and
 * `AmChartsRealtimeChart.vue`.
 */
defineProps<RealtimeChartProps>()

const engine =
  CHART_ENGINE === 'amcharts' ? AmChartsRealtimeChart : ChartJsRealtimeChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
